/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {usePublic} from "../../../Hooks/PermissionHooks";
import {StreamBankLink} from "../../Common/StreamBankLink";
import React from "react";

export const ToolbarItem = (props) => {
    const isPublic = usePublic();
    
    const {
        disabled = false,
        active = false,
        title,
        code,
        display
    } = props;
    
    if (!display || (isPublic && disabled)) {
        return null;
    }
    
    if (!disabled) {
        return (
            <StreamBankLink
                key={code}
                className={"toolbar-item btn" + (active ? " active" : "")}
                Tool={code}
            >
                {title}
            </StreamBankLink>
        )
    }
    
    return (
        <div key={code} className="toolbar-item btn secondary outline-secondary toolbar-item-disabled">
            {title}
        </div>
    )
};
